   export const DELIVERY_METHODS = {
    DELIVERY: 'delivery',
    TABLE: 'table',
    PICKUP: 'pickup',
    PICKUP_POINT: 'pickupPoint'
   }